import React from 'react'
// import { useHistory } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

function NotFound() {
    let history = useHistory()
    return (
      <div
        id="notfound"
      >
        <div class="notfound">
          <div class="notfound-404">
            <h1>Oops!</h1>
            <h2>404 - The Page can't be found</h2>
          </div>
          <p className="btn btn-outline-info" onClick={() => history.push("/")}>
            Go To Homepage
          </p>
        </div>
      </div>
    );
}

export default NotFound;
